/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionRule } from '../../models/distribution-rule';

export interface CreateRule$Params {
  'Active-Tenant-Identifier': string;
      body: DistributionRule
}

export function createRule(http: HttpClient, rootUrl: string, params: CreateRule$Params, context?: HttpContext): Observable<StrictHttpResponse<DistributionRule>> {
  const rb = new RequestBuilder(rootUrl, createRule.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DistributionRule>;
    })
  );
}

createRule.PATH = '/distribution-rules';
